import {DOCUMENT} from '@angular/common';
import {inject, Injectable, OnDestroy} from '@angular/core';

const DASHBOARD_EDITING_CLASS = 'dashboard-editing';

@Injectable({providedIn: 'root'})
export class DashboardEditModeService implements OnDestroy {
  private readonly document: Document = inject(DOCUMENT);
  private active: boolean = false;

  public get isActive(): boolean {
    return this.active;
  }

  public enter(): void {
    this.active = true;
    this.document.body.classList.add(DASHBOARD_EDITING_CLASS);
  }

  public leave(): void {
    this.active = false;
    this.document.body.classList.remove(DASHBOARD_EDITING_CLASS);
  }

  public ngOnDestroy(): void {
    this.leave();
  }
}
